<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <b-container>
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">Choose the best plan for your business</h1>
              <payment></payment>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="10">
          AHH
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import Payment from "@/components/Payment";
export default {
  name: "pricing-page",
  components: {
    Payment
  },
  data() {
    return {
      features: [
        {
          title: "Ping frequency",
          bravo: '<span class="text-sm text-light">Every 5 minutes</span>',
          alpha: '<span class="text-sm text-light">Every 1 minute</span>'
        },
        {
          title: "Number of monitors",
          bravo: '<span class="text-sm text-light">5</span>',
          alpha: '<span class="text-sm text-light">∞</span>'
        },
        {
          title: "Slack notifications",
          bravo: '<i class="fas fa-check text-success"></i>',
          alpha: '<i class="fas fa-check text-success"></i>'
        },
        {
          title: "Email notifications",
          bravo: '<i class="fas fa-check text-success"></i>',
          alpha: '<i class="fas fa-check text-success"></i>'
        },
        {
          title: "SMS notifications",
          bravo: "-",
          alpha: '<i class="fas fa-check text-success"></i>'
        },
        {
          title: "Private status pages",
          alpha: '<i class="fas fa-check text-success"></i>',
          bravo: "-"
        },
        {
          title: "Subscribers",
          alpha: "1000",
          bravo: "100"
        }
      ]
    };
  }
};
</script>
<style></style>
